import { ArrowRight } from "lucide-react";
import { APPLY_URL } from "@/lib/constants";

export function Nav() {
  return (
    <header
      data-testid="site-nav"
      className="fixed inset-x-0 top-0 z-50 border-b border-black/10 bg-[#F4F2EC]/80 backdrop-blur-xl"
    >
      <div className="mx-auto flex max-w-[1600px] items-center justify-between px-5 py-4 md:px-10">
        <a href="#top" data-testid="nav-logo" className="flex items-baseline gap-3">
          <img src="/assets/logo-dark.png" alt="DSA eCommerce" className="h-7 w-auto" />
          <span className="hidden font-mono2 text-[10px] uppercase tracking-[0.25em] text-ink/50 sm:inline">
            Est. 2016 · eCommerce
          </span>
        </a>
        <div className="flex items-center gap-4 md:gap-8">
          <div
            data-testid="nav-spots-indicator"
            className="hidden items-center gap-2 font-mono2 text-[10px] uppercase tracking-[0.2em] text-ink/70 md:flex"
          >
            <span className="h-2 w-2 animate-pulse-dot rounded-full bg-signal" />
            10 seats only
          </div>
          <a
            href={APPLY_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="nav-book-button"
            className="group inline-flex items-center gap-2 bg-ink px-5 py-2.5 font-mono2 text-[11px] font-medium uppercase tracking-[0.15em] text-white transition-colors duration-200 hover:bg-signal hover:text-white"
          >
            Book a Call
            <ArrowRight className="h-3.5 w-3.5 transition-transform duration-200 group-hover:translate-x-1" />
          </a>
        </div>
      </div>
    </header>
  );
}
